import { useState } from "react";

const faqs = [
  {
    question: "Does Sous only provide recipes?",
    answer: "Nope, Sous can do way more than that. While chatting with Sous you can get all sorts of helpful home-cooking tips and advice Sous can even help rescue recipes going wrong. We don't stop after the recipe is made either; you can edit your recipes, save them for later, add them to a calendar to plan your week ... Sous does so much more than just recipes"
  },
  {
    question: "What do I get by upgrading to Pro?",
    answer: "There are a lot of great reasons to upgrade to Pro. Pro users have unlimited recipes, so you can have as many personalised recipes created for you as you like. There is no limit on the recipe adjustments either. You'll not be shown ads anymore while using Sous. You will no longer be limited to only 10 favourited recipes, you'll have unlimited favourites. You can also see your entire conversation and recipe history rather than only the past 30 days."
  },
  {
    question: "How do I upgrade to Pro?",
    answer: "It's easy to upgrade to Pro, you can follow the banners or prompts when you hit a free tier limit or click the subscribe button from the My Account Settings page. You will have the option to subscribe in your own currency on a rolling monthly or annual basis."
  },
  /* CONVERSATIONS & RECIPES */
  {
    question: "How can I start a new conversation?",
    answer: "To start a fresh converstation click the reset icon in the top right of the chat screen. You can always get back to this conversation later via the Recent Chat History."
  },
  {
    question: "Can I resume a previous conversation?",
    answer: "Absolutely, from the top navigation head to the Recent Chat History page and click a conversation to jump back into it."
  },
  {
    question: "Can I use a photo to get a recipe?",
    answer:"Of course, whether it is a photo of a dish you've had somewhere or the inside of your fridge we can take a photo and start generating recipes for you."
  },
  {
    question: "Can I change a recipe once it's been created?",
    answer: "Yes, of course! Personalisation is what we're all about. When we create a recipe for you if you're not happy with something or don't have one of the ingredients simply keep chatting with Sous and we'll make the adjustments until we've got it just right for you! You can also edit the quantity of a recipe later as well, when you've got that favourite recipe for 2 but want to scale it up for 4 or 6 - it's easy, we do all the work for you adjusting quantities and cooking times."
  },
  {
    question: "Can I share a recipe?",
    answer: "Yes! When viewing a recipe, click 'Share' to get a link you can send to friends or family."
  },
  {
    question: "How do I save recipes?",
    answer: "When you're logged in and viewing a recipe, click the heart icon. A red heart means this recipe is already a favourite."
  },
  {
    question: "How do I find my recipes again?",
    answer:"From the menu head to Recipe Book, this contains all your recipes and some handy search and filter tools to help you find what you're looking for."
  },
  /* COOK MODE */
  {
    question: "Can I have the instructions read out to me?",
    answer:"Absolutely, enter Cook Mode on a recipe by clicking 'Cook It' and from here you can swipe from step to step and have the instructions read out loud for hands free help from Sous."
  },  
  {
    question: "What is Cook Mode?",
    answer: "Cook Mode is where we let you step through the instructions one step at a time, you can have them read out aswell while you focus on the tasks at hand. We also have all the ingredients shown so you don't need to flick back and forth to check quantities or how to prepare anything."
  },
  /* CALENDAR */
  {
    question: "How do I use meal planning?",
    answer:"When viewing a recipe, you simply tap the calendar icon to add it to your weekly plan. You can also add meals from the Calendar page, tap Add recipe to open the recipe finder, where you can search all your previous recipes."
  },
  {
    question: "Why use meal planning?",
    answer:"Meal planning helps you keep the recipes you've planned to cook together in the Calendar page. You also have the recipes planned for today available from the Home screen. We also have a brilliant feature in the Calendar page to help with planning and reduce food waste, once you've planned a few days you can get recipe suggestions for meals with similar ingredients to add to your plan - keeping things interesting and reducing the nnumber of differnt ingredents needed."
  },
  {
    question: "Can I get a shopping list for my planned recipes?",
    answer: "Naturally, we even make sure everything is intelligently grouped together in the list, and you can add any other items you want too so you only need to focus on one list while shopping.",
  },
  /* MEAL PLANS */
  {
    question: "What is a mealplan?",
    answer: "A mealplan is how you create a collection of recipes, you can view all the ingredients and cooking steps in one place to help you plan for a multi-recipe meal."
  },
  /* ACCOUNT */
  {
    question: "How do I reset my password?",
    answer: "Go to the login page and click 'Forgot Password'. We'll send a reset link to your email. You can also request a reset link from the My Account Settings page"
  },
  {
    question: "How do I update my preferences?",
    answer: "Head to the Preferences page from the top navigation. You can update dietary restrictions, servings, goals and more."
  },
  {
    question: "Why do I get logged out sometimes?",
    answer: "Your session may expire after some time for security. Just log in again to continue using Sous."
  },

  /*{
    question: "",
    answer: ""
  }*/

];

export default function HelpPage() {
  const [openIndex, setOpenIndex] = useState(null);
  const [query, setQuery] = useState("");

  const filteredFaqs = faqs.filter(faq =>
    faq.question.toLowerCase().includes(query.toLowerCase()) ||
    faq.answer.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="max-w-3xl mx-auto px-4 mt-10 space-y-6">
      <h1 className="text-3xl font-bold text-[#1F2937]">Help & FAQs</h1>
      <p className="text-gray-600">
        Need help using Sous? Search or browse below.
      </p>

      <input
        type="text"
        placeholder="Search FAQs..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-sage"
      />

      <div className="space-y-4">
        {filteredFaqs.length === 0 ? (
          <p className="text-sm text-gray-500">No results found.</p>
        ) : (
          filteredFaqs.map((faq, index) => (
            <div key={index} className="border rounded p-4">
              <button
                onClick={() => setOpenIndex(index === openIndex ? null : index)}
                className="text-left w-full text-lg font-medium text-charcoal"
              >
                {faq.question}
              </button>
              {openIndex === index && (
                <p className="mt-2 text-gray-700 text-sm">{faq.answer}</p>
              )}
            </div>
          ))
        )}
      </div>

      <p className="text-sm text-gray-500 py-6">
        Still stuck? Or have some feedback - I'd love to hear it.{" "}
        <a
          href="mailto:support@sous.uk"
          className="text-blue-500 hover:underline"
        >
          Send an email,
        </a>{" "}
        and we’ll set things right.
      </p>
    </div>
  );
}
